export enum ECexOrderSide {
  buy = 'buy',
  sell = 'sell',
}

export enum ECexOrderStatus {
  success = 'success',
  active = 'active',
  canceled = 'canceled',
  filled = 'filled',
  partially_filled = 'partially_filled',
  error = 'error',
  failed = 'failed',
}

export enum ECexOrderBot {
  organic = 'organic',
  cm = 'cm',
  fg = 'fg',
  order_manager_bot = 'order-manager-bot',
  orderbook = 'orderbook',
  dn_orderbook = 'dn-orderbook',
  ob_protection = 'ob_protection',
  buysell = 'buysell',
  buysellv2 = 'buysellv2',
  orderbook_dynamic = 'orderbook_dynamic',
  index = 'index',
  counter_order = 'counter-order',
  abuse_protection = 'abuse_protection',
  arbitrage = 'arbitrage',
  true_sl_price = 'true-sl-price',
  true_sl_volume = 'true-sl-volume',
  unknown = 'unknown',
}

export enum TimeInForce {
  GTC = 'GTC',
  IOC = 'IOC',
  FOK = 'FOK',
  PostOnly = 'PostOnly',
}

export interface ICexOrder {
  account_id: number;
  amount_usd: string;
  base_amount: string;
  base_fee: string;
  bot: ICexActiveOrderBot;
  cex: string;
  cex_client_order_id: string;
  cex_order_id: string;
  created_at: string;
  deleted_at: string;
  fact_base_amount: string;
  fact_price: string;
  fact_quote_amount: string;
  id: number;
  locked_until: string;
  metadata?: string;
  pair_id: number;
  price: string;
  project_id: number;
  quote_amount: string;
  quote_fee: string;
  reserved_released: boolean;
  sequence_no: number;
  side: ECexOrderSide;
  status: string;
  updated_at: string;
  account_notes?: string;
  time_in_force: TimeInForce;
}

export type ICexActiveOrderBot =
  | 'abuse_protection'
  | 'arbitrage'
  | 'buysell'
  | 'buysellv2'
  | 'cm'
  | 'counter-order'
  | 'fg'
  | 'index'
  | 'orderbook'
  | 'delta_neutral_ob'
  | 'orderbook_dynamic'
  | 'ob_protection'
  | 'order-manager-bot'
  | 'organic'
  | 'regular'
  | 'true-sl-price'
  | 'true-sl-volume'
  | 'unknown';
